import { render, staticRenderFns } from "./bindingRelationship.vue?vue&type=template&id=32c3a0af&scoped=true&"
import script from "./bindingRelationship.vue?vue&type=script&lang=js&"
export * from "./bindingRelationship.vue?vue&type=script&lang=js&"
import style0 from "./bindingRelationship.vue?vue&type=style&index=0&id=32c3a0af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c3a0af",
  null
  
)

export default component.exports